import React from 'react';
import { DaOffer, Platform } from '../../types';
import DealerCard from '@wix/da-ds/pkg/DealerCard';

import s from './ComplexBanner.scss';

export interface Props {
  banner: NonNullable<DaOffer['asset']['creative']['complexbanner']>;
  platform: Platform;
  onCtaClick: (url: string) => void;
}

const ComplexBanner: React.FC<Props> = ({
  banner: bannerOffer,
  platform,
  onCtaClick,
}) => {
  // Mobile is optional but usually comes as empty object so fallback to desktop when not present
  let banner: Partial<typeof bannerOffer.desktop> = bannerOffer.desktop;
  if (
    platform === 'mobile' &&
    bannerOffer.mobile &&
    Object.keys(bannerOffer.mobile).length > 0 &&
    bannerOffer.mobile.cta?.url
  ) {
    banner = bannerOffer.mobile!;
  }

  if (!bannerOffer || !banner) {
    return null;
  }

  return (
    <DealerCard
      className={s['root']}
      onCtaClick={url => onCtaClick(url ?? '')}
      {...(banner as any)}
    />
  );
};

export default ComplexBanner;
